"use client";

import { useEffect, useState } from "react";

const DEV_DOMAINS = [
  "dev.mpgo.ru",
  "dev.advcrm.ru",
  "localhost",
  "127.0.0.1",
];

const BANNER_HEIGHT_PX = 36;
const CSS_VAR_NAME = "--dev-banner-height";

/**
 * Баннер для DEV/TEST окружения.
 * Определяет среду по текущему домену в браузере
 * и экспонирует свою высоту через CSS-переменную
 * --dev-banner-height, чтобы фиксированные/липкие элементы
 * интерфейса (sidebar, top bar, мобильное меню) могли
 * корректно позиционироваться под ним.
 *
 * Раскладка (dev):
 *   y=0..36   — DEV-баннер (sticky top-0 z-50, на всю ширину страницы)
 *   y=36..100 — шапка сайдбара (MPGO) + TopBar (одной высоты, h-16)
 *   y=100..∞  — навигация сайдбара + контент страницы
 */
export function DevBanner() {
  const [isDev, setIsDev] = useState(false);

  useEffect(() => {
    const explicitMode = process.env.NEXT_PUBLIC_APP_MODE;
    if (explicitMode === "dev") {
      setIsDev(true);
      return;
    }
    if (explicitMode === "prod") {
      setIsDev(false);
      return;
    }

    const hostname = window.location.hostname;
    const isDevEnvironment = DEV_DOMAINS.some(
      (domain) => hostname === domain || hostname.endsWith("." + domain)
    );

    setIsDev(isDevEnvironment);
  }, []);

  useEffect(() => {
    const root = document.documentElement;
    root.style.setProperty(
      CSS_VAR_NAME,
      isDev ? `${BANNER_HEIGHT_PX}px` : "0px"
    );
    return () => {
      root.style.removeProperty(CSS_VAR_NAME);
    };
  }, [isDev]);

  if (!isDev) return null;

  return (
    <div
      className="sticky top-0 z-50 flex items-center justify-center bg-orange-500 px-4 text-center text-sm font-bold text-white"
      style={{ height: BANNER_HEIGHT_PX }}
    >
      ⚠️ DEV / TEST ENVIRONMENT — НЕ ПРОД! ⚠️
    </div>
  );
}
